export const Footer = (props) => {
  
  return (
    <div>
      <div id='footer' style={{
      backgroundColor: '#171e24'
    }}>
        <div className='container text-center'>
          <p>
            &copy; 2025 by PROTO
          </p>
        </div>
      </div>
    </div>
  )
}
